import styled from "styled-components";
import React from "react";

export const Container = styled.div`
  margin: 1rem auto;
  background-color: #e6e6e6;
  border-radius: 10px;
  width: 80%;
  max-width: 1000px;
  @media screen and (max-width: 1200px) {
    width: 90%;
  }
`;

export const Title = styled.h1`
  &&& {
    margin: 2rem auto;
  }
  font-size: 2.4rem;
  width: fit-content;
  display: block;
`;

export const ImageDrop = styled.img.attrs({
  src: "/assets/icons/imageDrop.svg",
})`
  &&& {
    margin: 2rem auto;
  }
  display: block;
  width: 20rem;
`;

export const Edit = styled.img.attrs({
  src: "/assets/icons/edit.svg",
})`
  width: 2rem;
  margin: 0 0.8rem;
`;

export const EditButton = styled(({ type, children, ...props }) => (
  <button type={type} {...props}>
    {children}
    <Edit />
  </button>
))`
  cursor: pointer;
  &&& {
    margin: 2rem auto;
  }
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.secondary};
  border-radius: 10px;
  color: white;
  border: none;
  padding: 1.5rem 2.5rem;
  resize: none;
`;

export const SubTitle = styled.h3`
  font-size: 1.5rem;
  &&& {
    display: block;
    margin: 1rem auto;
    width: fit-content;
  }
`;

export const Description = styled.textarea`
  border-radius: 10px;
  background-color: white;
  width: 50rem;
  padding: 1rem;
  &&& {
    display: block;
    margin: 1rem auto;
  }
`;
